import React from 'react';

const ClozeConvoFeedback = ({
    correctAnswer,
    selectedAnswer,
    passage,
}) => {
    let userFeedback = !!passage && passage.map((phrase, i) => {
        phrase = phrase.replace(/\n/g, "<div/>");
        return <span key={i}> 
                <div className="converse-box">   <p dangerouslySetInnerHTML={{__html:phrase}}/></div>
                {!!selectedAnswer && !!selectedAnswer[i] ?
                    <div className="converse-box">
                       { selectedAnswer[i] !== correctAnswer[i] && <p className='converse-added-wrong' data-id="15753593663">{selectedAnswer[i]}</p>}
                         <p className='converse-added-correct' data-id="15753593663">{correctAnswer[i]}</p>
                    </div> : 
                null } 
               </span>
    })

    return (
        <div class="converse-container" id="converse-95549859">                           
            <div class="converse-all">
                {userFeedback}                                   
            </div>
        </div>
    )
}

export default ClozeConvoFeedback;